export function toFriendlyTime(timeUTZ) {
  const time = new Date(timeUTZ);
  const friendlyTime = time.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit"
  });

  return friendlyTime;
}

export function toFriendlyTimeWithAMPM(timeUTZ) {
  const time = new Date(timeUTZ);
  return time.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true
  });
}

export function toFriendlyTimeAMPMObj(timeUTZ) {
  const time = new Date(timeUTZ);
  let hours = time.getHours();
  let minutes = time.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  return { hours: hours, minute: minutes, ampm: ampm };
}

function TimezoneDetect() {
  var dtDate = new Date("1/1/" + new Date().getUTCFullYear());
  var intOffset = 10000; //set initial offset high so it is adjusted on the first attempt
  var intMonth;
  var intHoursUtc;
  var intHours;
  var intDaysMultiplyBy;

  // Go through each month to find the lowest offset to account for DST
  for (intMonth = 0; intMonth < 12; intMonth++) {
    //go to the next month
    dtDate.setUTCMonth(dtDate.getUTCMonth() + 1);

    // To ignore daylight saving time look for the lowest offset.
    // Since, during DST, the clock moves forward, it'll be a bigger number.
    if (intOffset > dtDate.getTimezoneOffset() * -1) {
      intOffset = dtDate.getTimezoneOffset() * -1;
    }
  }

  return intOffset;
}

export function getTimeZoneString() {
  const offset = new Date().getTimezoneOffset() / -60;
  switch (offset) {
    case 0:
      return "UTC";
    case 1:
      return "BST";
    case -4:
      return "EDT";
    case -5:
      return "CDT";
    case -6:
      return "MDT";
    case -7:
      return "PDT";
    case -8:
      return "AKDT";
    default:
      return "UTC " + (offset > 0 ? "+" : "") + offset.toString();
  }
}
